export default "__VITE_ASSET__Clb_BNnT__"